<template>
  <div class="whitespace-nowrap max-w-sm">
    <div class="buttons">
      <button @click="fat.setPreferredTimeWithOffset('12:00', 90)" :class="{ 'active': ['11:00', '12:00', '13:00'].includes(fat.preferredTime) && !isAllDay }">
        <AtomIcon name="plate-utensils" class="icon" />
        <span>{{ $t('shared.lunch') }}</span>
      </button>
      <button @click="fat.setPreferredTimeWithOffset('19:00', 90)" :class="{ 'active': ['17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'].includes(fat.preferredTime) && !isAllDay }">
        <AtomIcon name="martini-glass" class="icon" />
        <span>{{ $t('shared.dinner') }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
const fat = useFatStore()

// Check if time is all day
const isAllDay = computed(() => '10:00' === fat.startTime && '23:00' === fat.endTime)
</script>

<style lang="scss" scoped>
.buttons {
  @apply flex items-center gap-4 md:gap-6;

  button {
    @apply flex items-center gap-1.5 duration-300;
    &.active {
      @apply border-coral text-coral;

      &:deep(div) {
        @apply duration-300 text-coral;
      }
    }

    .icon {
      @apply text-[1rem];
    }

    span {
      @apply block text-sm md:text-base;
    }
  }
}
</style>